import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpHelper } from 'src/app/common/index';
import { HttpClient } from '@angular/common/http';

@Injectable()
export class TicketReportService {

  constructor(public httpHelper: HttpHelper,
              private http: HttpClient) {

  }

  getAssignedUsers():Observable<any> {
    return this.httpHelper.getRequest(`/tickets/report/assigned-users`);
  }
  getFilters(values?: any):Observable<any> {
    return this.httpHelper.postRequest(`/tickets/report/filters`, values);
  }

  getPriorityStats(values?: any): Observable<any> {
    const endpoint = '/tickets/report/priority-stats';
    return this.httpHelper.getRequestWithParams(endpoint, values);
  }

  getStatusCounts(values?: any): Observable<any> {
    const endpoint = '/tickets/report/status-counts';
    return this.httpHelper.getRequestWithParams(endpoint, values);
  }

  getTrendsOverTime(values?: any): Observable<any> {
    const endpoint = '/tickets/report/trends-over-time';
    return this.httpHelper.getRequestWithParams(endpoint, values);
  }

  getAssigneePerformance(values?: any): Observable<any> {
    const endpoint = '/tickets/report/assignee-performance';
    return this.httpHelper.getRequestWithParams(endpoint, values);
  }

  getTicketsByCategory(values?: any): Observable<any> {
    const endpoint = '/tickets/report/tickets-by-category';
    return this.httpHelper.getRequestWithParams(endpoint, values);
  }

  getTicketsByArt(values?: any): Observable<any> {
    const endpoint = '/tickets/report/tickets-by-art';
    return this.httpHelper.getRequestWithParams(endpoint, values);
  }

  getTicketsByUser(values?: any): Observable<any> {
    const endpoint = '/tickets/report/tickets-by-user';
    return this.httpHelper.getRequestWithParams(endpoint, values);
  }

}
